import { Box } from '@mui/system';
import { useDown } from 'hooks/useBreakpoints/useBreakpoints';
export function PaidFeatureAlertDialogHeadDraft(): JSX.Element {
  const isDonwSM = useDown('sm');

  if (isDonwSM) {
    return (
      <Box width="100%">
        <Box
          sx={{
            margin: 'auto',
            backgroundColor: '#3C3C43',
            opacity: 0.3,
            height: '5px',
            width: '62px',
            borderRadius: '2.5px',
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
        />
      </Box>
    );
  } else {
    return <></>;
  }
}

export default PaidFeatureAlertDialogHeadDraft;
